export class DietaryLabel {
  constructor(
    public title: string = null,
    public key: string = null,
    public imgUrl: string = null
  ) {
  }
}

export const DIETARY_LABEL = [
  new DietaryLabel('Dairy free', 'dairy_free', './assets/icon/dairy-free.png'),
  new DietaryLabel('Gluten free', 'gluten_free', './assets/icon/gluten-free.png'),
  new DietaryLabel('Halal', 'halal', './assets/icon/halal.png'),
  new DietaryLabel('Vegan', 'vegan', './assets/icon/vegan.png'),
  new DietaryLabel('Vegetarian', 'vegetarian', './assets/icon/vegetarian.png')
];
